export default function Loader(elm) {
  return elm
}
